// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"b4af74cb","377":"c2ad95af","426":"aa1cd6d8","730":"6e862418","752":"4f4a29ed","844":"4acb9194","875":"ee484012","946":"aba2194d"}[chunkId] + ".chunk.js";
};